import type { Column } from "@tanstack/react-table";
import type { CSSProperties } from "react";

import { cn } from "@/lib/cn";

export function getColumnPinningStyle<TData>(
  column: Column<TData>,
): CSSProperties {
  const isPinned = column.getIsPinned();

  return {
    position: isPinned ? "sticky" : "relative",
    zIndex: isPinned ? 1 : undefined,
    left: isPinned === "left" ? `${column.getStart("left")}px` : undefined,
    right: isPinned === "right" ? `${column.getAfter("right")}px` : undefined,
  };
}

export function getColumnPinningClassName<TData>(
  column: Column<TData>,
  isScrolling: boolean,
): string {
  if (!column.getIsPinned()) return "";

  return cn("bg-inherit transition-colors", isScrolling && "shadow-md");
}
